import { makeStyles } from 'tss-react/mui';

export const usePaymentTermsPopupStyles = makeStyles()(() => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    margin: '20px 0',
  },
  fieldRow: {
    display: 'grid',
    gridTemplateColumns: `repeat(3, 30%)`,
    gap: '3%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignContent: 'center',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  button: {
    margin: '20px 5px 5px',
  },
}));
